import store from '@/stores';
import { accountsAPI } from '@/services';

// Same role as the API's role:super middleware on v1/backoffice/communications;
// ids come from roleManager.mixin.js (6 = super).
const ALLOWED_ROLE_IDS = [6];

export function canAccessCommunications(userInfo) {
  const roles = userInfo?.roles_ids || [];
  return roles.some((id) => ALLOWED_ROLE_IDS.includes(id));
}

// On direct navigation (F5) the guard runs before App.vue's /users/me and the store is empty:
// fetch here instead of blocking users who have access.
async function getLoadedUserInfo() {
  if (store.state.user.userInfo?.id) return store.state.user.userInfo;

  const { data } = await accountsAPI.getInfoUser();
  store.dispatch('user/SET_USER_DATA', data);

  return data;
}

export async function communicationsBeforeEnter(to, from, next) {
  const fallback = from.name ? { name: from.name } : { name: 'login' };

  try {
    const userInfo = await getLoadedUserInfo();

    if (canAccessCommunications(userInfo)) next();
    else next(fallback);
  } catch {
    next(fallback);
  }
}
